module.exports = __webpack_public_path__ + "advanced4.png?8892a0826c2120dd76c3b781fad31028";